import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toTsv } from "@/lib/csv";

// 표 전체를 탭 구분 텍스트로 클립보드에 복사(2026-07-18) — 노션/구글시트/엑셀에
// 붙여넣으면 표로 들어간다. CSV 다운로드(ExportButton)와 나란히 두는 짝 버튼:
// "파일로 보관"은 CSV, "다른 데 붙여넣기"는 복사.
export default function CopyButton({ rows, disabled }) {
  const [done, setDone] = useState(false);
  const empty = !rows || rows.length <= 1;

  async function copy() {
    try {
      await navigator.clipboard.writeText(toTsv(rows));
      setDone(true);
      setTimeout(() => setDone(false), 1500);
    } catch {
      // 클립보드 권한 거부 등 — 실패해도 대시보드 사용엔 지장 없게 조용히 무시
    }
  }

  return (
    <button
      type="button"
      onClick={copy}
      disabled={disabled || empty}
      title="표 전체 복사 — 노션·시트에 붙여넣으면 표로 들어갑니다"
      className={`inline-flex items-center gap-1 rounded-lg px-2.5 py-2 text-xs font-medium disabled:opacity-40 ${
        done ? "bg-emerald-50 text-emerald-700" : "bg-ink-50 text-ink-600 hover:bg-ink-100"
      }`}
    >
      {done ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      {done ? "복사됨" : "복사"}
    </button>
  );
}
